import { render, staticRenderFns } from "./DialogOrderResult.vue?vue&type=template&id=c0de7b84&scoped=true&"
import script from "./DialogOrderResult.vue?vue&type=script&lang=js&"
export * from "./DialogOrderResult.vue?vue&type=script&lang=js&"
import style0 from "./DialogOrderResult.vue?vue&type=style&index=0&id=c0de7b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0de7b84",
  null
  
)

export default component.exports